"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPrice = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));
var _excluded = ["children", "price"];
var HotelOfferPrice = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children,
    price = _ref.price,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  return /*#__PURE__*/_react["default"].createElement(StyledHotelOfferPrice, rest, children, /*#__PURE__*/_react["default"].createElement(StyledPrice, {
    value: price,
    currencyCode: code
  }));
});
HotelOfferPrice.displayName = 'HotelOfferPrice';
HotelOfferPrice.propTypes = {
  price: _propTypes["default"].number.isRequired
};
var StyledPrice = exports.StyledPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelOfferPrice__StyledPrice",
  componentId: "sc-1v3l0l6-0"
})(["font-size:18px;font-style:normal;font-weight:500;line-height:22px;"]);
var StyledHotelOfferPrice = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferPrice__StyledHotelOfferPrice",
  componentId: "sc-1v3l0l6-1"
})(["display:flex;align-items:center;justify-content:center;gap:2px;"]);
var _default = exports["default"] = HotelOfferPrice;